export default __webpack_public_path__ + "static/media/client-dislike.e6442825.svg";